<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper meter-opp">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="contact-head">
            <div class="row align-items-center">
              <div class="col-sm-6">
                <ul class="contact-breadcrumb">
                  <li>
                    <router-link :to="{ path: '/crm/support-case-list' }">
                      <i class="ti ti-arrow-narrow-left"></i>
                      Support Tickets
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="card">
                <div class="card-body settings-form">
                  <Form @submit="createCase" :validation-schema="schema">
                    <div class="row align-items-center mb-3">
                      <div class="col-6">
                        <h4>Create Ticket</h4>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-wrap">
                          <label class="col-form-label">Title <span class="text-danger">*</span></label>
                          <div class="">
                            <Field name="subject" type="text" class="form-control" placeholder=""
                              v-model="form.subject" />
                          </div>
                          <ErrorMessage name="subject" class="text-danger" />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-wrap">
                          <label class="col-form-label">Status</label>
                          <Field as="select" name="C" class="form-select readonly" v-model="form.status" disabled>
                            <option value=""> ----select---- </option>
                            <option v-for="res in Options.status" :key="res.value" :value="res.value">
                              {{ res.text }}
                            </option>
                          </Field>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-wrap">
                          <label class="col-form-label">Priority</label>
                          <Field as="select" name="priority" class="form-select" v-model="form.priority">
                            <option value="">
                              ----select----
                            </option>
                            <option v-for="res in Options.priority" :key="res.value" :value="res.value">
                              {{ res.text }}
                            </option>
                          </Field>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-wrap">
                          <label class="col-form-label">Type</label>
                          <Field as="select" name="type" class="form-select" v-model="form.type">
                            <option value="">
                              ----select----
                            </option>
                            <option v-for="res in Options.type" :key="res.value" :value="res.value">
                              {{ res.text }}
                            </option>
                          </Field>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-wrap">
                          <label class="col-form-label">Description</label>
                          <textarea class="form-control" rows="4" v-model="form.description"></textarea>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="form-wrap">
                          <div><label class="col-form-label">Attachments</label></div>

                          <!-- Upload Icon -->
                          <div class="upload-icon">
                            <button type="button" class="btn d-flex align-items-center gap-2" @click="triggerFileInput"
                              style="background-color: #f1f1f1; color: #6c757d; border: none; padding: 6px 12px; border-radius: 6px;">
                              <i class="ti ti-paperclip" style="font-size: 18px;"></i>
                              <!-- Attachments -->
                            </button>
                          </div>

                          <!-- Hidden File Input -->
                          <input type="file" ref="fileInput" @change="handleFileUpload" multiple
                            style="display: none;" />


                          <div class="file-container">
                            <div v-for="(file, index) in previewImages" :key="index" class="attachment-preview">
                              <!-- 📷 Image Preview -->
                              <div v-if="isImage(file?.file?.name || file.file_url)">
                                <a :href="file.file_url" target="_blank">
                                  <img :src="file.file_url" alt="Image Preview" style="cursor: pointer;" />
                                </a>
                              </div>

                              <!-- 📄 PDF Preview -->
                              <!-- <div v-else-if="isPDF(file.file.name)">
                              <iframe :src="file.file_url" type="application/pdf" width="100%" height="300"></iframe>
                            </div> -->

                              <!-- 🎧 Audio Preview -->
                              <div v-else-if="isAudio(file?.file?.name || file.file_url)">
                                <audio controls :src="file.file_url"></audio>
                              </div>

                              <!-- 🎞 Video Preview -->
                              <div v-else-if="isVideo(file?.file?.name || file.file_url)">
                                <video controls width="100%">
                                  <source :src="file.file_url" type="video/mp4" />
                                  Your browser does not support the video tag.
                                </video>
                              </div>

                              <!-- 🧾 Word, Excel, TXT, Others -->
                              <div v-else class="file-placeholder">
                                <i class="fas fa-file-alt me-1"></i>
                                <a :href="file.file_url" target="_blank" class="file-link">
                                  {{ getFileName(file?.file?.name || file.file_url) }}
                                </a>
                              </div>

                              <!-- ❌ Remove File -->
                              <button type="button" @click="removeImage(index)" class="remove-btn">×</button>
                            </div>
                          </div>


                        </div>
                      </div>

                    </div>
                    <div class="submit-button text-end">
                      <!-- <router-link to="/crm/contracts-list" class="btn btn-light">Back</router-link> -->
                      <button type="button" class="btn btn-light" @click="handleCancel">
                        Back
                      </button>
                      <button type="submit" class="btn btn-primary">Create</button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  watch,
  onMounted,
  computed,
} from "vue";
import {
  useStore
} from "vuex";
import {
  useRoute,
  useRouter
} from 'vue-router';
import Multiselect from 'vue-multiselect';

import {
  Form,
  Field,
  ErrorMessage,
  useForm
} from "vee-validate";
import * as Yup from "yup";
import { changeFormate } from '../../../../util'
import { message } from "ant-design-vue";
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  data() {
    return {
      dateFormat: "dd/MM/yyyy",
      title: "Case",
    };
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const Options = computed(() => store.getters['suppportCases/getcasesDropdowns']);
    const fileInput = ref(null)
    const previewImages = ref([])

    const triggerFileInput = () => {
      fileInput.value.click()
    }

    const handleFileUpload = async (event) => {
      const files = Array.from(event.target.files)
      files.forEach((file) => {
        const file_url = URL.createObjectURL(file)
        previewImages.value.push({ file, file_url, id: '' })
      })
      // reset input so same file can be uploaded again if needed
      fileInput.value.value = ''
    }

    const removeImage = async (index) => {
      previewImages.value.splice(index, 1)
    }

    const isImage = (fileUrl) => {
      return /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(fileUrl);
    }
    const isPDF = (fileUrl) => {
      return /\.pdf$/i.test(fileUrl);
    }
    const isAudio = (fileUrl) => {
      return /\.(mp3|wav|ogg)$/i.test(fileUrl);
    }
    const isVideo = (fileUrl) => {
      return /\.(mp4|webm|ogg)$/i.test(fileUrl);
    }
    const getFileName = (fileUrl) => {
      return fileUrl.split('/').pop();
    }

    const schema = Yup.object().shape({
      subject: Yup.string()
        .required("Name is required"),
    });

    const form = ref({
      id: '',
      subject: '',
      status: 'new',
      priority: null,
      type: null,
      description: '',
    });

    const createCase = async () => {
      try {
        const formData = new FormData()

        // Append form fields
        for (const key in form.value) {
          if (form.value[key] !== null && form.value[key] !== undefined) {
            formData.append(key, form.value[key])
          }
        }
        // Append uploaded images
        previewImages.value.forEach((imgObj) => {
          if (imgObj.file) {
            formData.append('documents[]', imgObj.file)
          }
        })

        // Dispatch with FormData
        let data = await store.dispatch('suppportCases/createCase', formData)
        if (data.status) {
          message.success(data.message)
          handleCancel()
        }
      } catch (error) {
        console.error('Error creating case:', error)
      }
    }

    const handleCancel = () => {
      router.push({
        path: "/crm/support-case-list",
      });
    }

    onMounted(async () => {
      await store.dispatch('suppportCases/fetchcasesOptions');
    });

    return {
      store,
      route,
      router,
      schema,
      Options,
      form,
      createCase,
      handleCancel,
      fileInput,
      previewImages,
      removeImage,
      handleFileUpload,
      triggerFileInput,
      isImage,
      isPDF,
      isAudio,
      isVideo,
      getFileName
    };
  },
};
</script>

<style lang="scss" scoped>
.meter-opp {
  .card {
    .card-body {
      min-height: 80vh;
    }
  }
}

img {
  transition: 0.2s;
}

img:hover {
  opacity: 0.8;
}

.upload-icon {
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 10px;
}

.attachment-preview {
  height: 90px;
  display: flex;
  align-items: center;
  background: #f2f2f2;
  border-radius: 6px;
  margin-bottom: 10px;
  overflow: hidden;
  position: relative;
  max-width: 300px;
}

.attachment-preview img {
  width: 100px;
  height: 70px;
  object-fit: cover;
  border-right: 1px solid #ccc;
}

.remove-btn {
  background: transparent;
  border: none;
  color: #000;
  font-size: 20px;
  margin-left: auto;
  padding: 0 12px;
  cursor: pointer;
}

// .attachment-preview {
//   position: relative;
//   margin-bottom: 20px;
// }

img,
iframe,
video {
  max-width: 100%;
  border-radius: 6px;
}

audio,
video {
  margin-top: 10px;
}

.file-placeholder {
  border: 1px dashed #ccc;
  padding: 12px;
  text-align: center;
  border-radius: 5px;
}

.file-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
</style>